import{mediaCSS,mediaMap,ZERO_BREAKPOINT}from"@redocly/reference-docs";import styled from"../../styled-components";export const ContentWrapper=styled.section`
  max-width: ${({theme:a})=>a.components.contentWrapper.maxWidth};
  width: 90%;
  margin: 0 auto;

  padding: ${({theme:a})=>`${a.components.contentWrapper.paddingVertical} ${a.components.contentWrapper.paddingHorizontal}`};

  & > article:first-child > h1:first-child {
    // disable margin top for h1 on the title heading if there is no "Last updated at" block
    margin-top: 0;
  }

  @media only screen and (min-width: ${({theme:a})=>a.breakpoints.medium}) {
    width: ${({withToc:a,theme:b})=>a?`calc(90% - ${b.tocPanel.width})`:"90%"};
  }
`;export const NavButtonsWrapper=styled(ContentWrapper)`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: flex-end;

  @media only screen and (min-width: ${({theme:a})=>a.breakpoints.small}) {
    flex-direction: row;
  }
`;export const NextPageWrapperWithRightPanel=styled(NavButtonsWrapper)`
  ${({theme:a})=>mediaCSS({paddingLeft:{[ZERO_BREAKPOINT]:0,[a.rightPanel.showAtBreakpoint]:25},paddingRight:{[ZERO_BREAKPOINT]:0,[a.rightPanel.showAtBreakpoint]:25},margin:{[ZERO_BREAKPOINT]:"0 auto",[a.rightPanel.showAtBreakpoint]:0},maxWidth:{[ZERO_BREAKPOINT]:a.components.contentWrapper.maxWidth,[a.rightPanel.showAtBreakpoint]:"none"},width:mediaMap(a.breakpoints,[a.rightPanel.width],{[ZERO_BREAKPOINT]:()=>"90%",[a.rightPanel.showAtBreakpoint]:a=>`calc(100% - ${a})`})})}
`;